import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './order-dnd-graphic.scss';

const OrderDndGraphic = ({itemData, isDragging, classes}) => {
	const [opacity, setOpacity] = useState(1);
	const [hasDragged, setHasDragged] = useState(false);
	const [shouldAnimate, setShouldAnimate] = useState(false);

	/* Class name */
	let className = 'OrderDndGraphic';
	if (classes && classes.length > 0) {classes.forEach((c) => {className += ' ' + c;});}

	useEffect(() => {
		/* Opacity (invisible if dragging) */
		if (isDragging) {
			setOpacity(0);
			setHasDragged(true);
		} else {
			setOpacity(1);
			// We dont want to start animating, before we have dragged
			if (hasDragged) {
				// Start animation
				setShouldAnimate(true);
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isDragging]);

	return (
		<div 
			className={className + (shouldAnimate ? ' animated' : '')} 
			style={{opacity}} 
			onAnimationEnd={() => {setShouldAnimate(false);}}>
			{(itemData && itemData.text) && <span>{itemData.text}</span>}
			<div className={'OrderDndGraphic-handle '}/>
		</div>
	);
};

OrderDndGraphic.propTypes = {
	itemData: PropTypes.object.isRequired,
	isDragging: PropTypes.bool.isRequired,
	classes: PropTypes.array,
};

export default OrderDndGraphic;